module.exports = {
  id: 14,
  name: 'Rainbow Reaches',
  categories: ['flexibility', 'arms', 'core'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'beginner',
  skill: 'Flexibility',
  points: 8,
  instructions:
    'Rainbow Reaches make you stretch like a rainbow! Stand with your feet apart, reach up with both arms, then reach over to one side like making a rainbow, then reach to the other side! This makes you flexible and strong!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to reach like a rainbow? Let us build incredible flexibility!',
    },
    {
      time: 3,
      text: 'Stand with your feet apart, arms at your sides!',
    },
    {
      time: 6,
      text: 'Get ready to reach up high and make beautiful rainbows!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Reach up high with both arms!',
    },
    // SET 1 - 6 cycles
    {
      time: 12,
      text: 'Perfect rainbow position! Feet apart, arms ready!',
    },
    {
      time: 15,
      text: 'Number 1! Reach up high with both arms, stretch toward the sky!',
    },
    {
      time: 18,
      text: 'Reach over to the right side, feel the stretch in your side!',
    },
    {
      time: 21,
      text: 'Reach over to the left side, stretch like a beautiful rainbow!',
    },
    {
      time: 24,
      text: 'Number 2! Reach up high with both arms, you are doing great!',
    },
    {
      time: 27,
      text: 'Reach over to the left side, feel the stretch in your side!',
    },
    {
      time: 30,
      text: 'Reach over to the right side, stretch like a beautiful rainbow!',
    },
    {
      time: 33,
      text: 'Number 3! Reach up high with both arms, stay focused!',
    },
    {
      time: 36,
      text: 'Reach over to the right side, feel the stretch in your side!',
    },
    {
      time: 39,
      text: 'Reach over to the left side, stretch like a beautiful rainbow!',
    },
    {
      time: 42,
      text: 'Number 4! Reach up high with both arms, keep going!',
    },
    {
      time: 45,
      text: 'Reach over to the left side, feel the stretch in your side!',
    },
    {
      time: 48,
      text: 'Reach over to the right side, stretch like a beautiful rainbow!',
    },
    {
      time: 51,
      text: 'Number 5! Reach up high with both arms, you are strong!',
    },
    {
      time: 54,
      text: 'Reach over to the right side, feel the stretch in your side!',
    },
    {
      time: 57,
      text: 'Reach over to the left side, stretch like a beautiful rainbow!',
    },
    {
      time: 60,
      text: 'Number 6! Reach up high with both arms, almost there!',
    },
    {
      time: 63,
      text: 'Reach over to the left side, feel the stretch in your side!',
    },
    {
      time: 66,
      text: 'Reach over to the right side, stretch like a beautiful rainbow!',
    },
    {
      time: 69,
      text: 'Great job! Take a deep breath and shake out your arms.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 72,
      text: 'Take a deep breath in and out, you are building incredible flexibility!',
    },
    {
      time: 75,
      text: 'Shake out your arms and shoulders, get ready for round two!',
    },
    {
      time: 78,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 81,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 2 - 6 cycles
    {
      time: 84,
      text: 'Stand with your feet apart, arms at your sides!',
    },
    {
      time: 87,
      text: 'Get ready to reach up high and make beautiful rainbows!',
    },
    {
      time: 90,
      text: 'Perfect rainbow position! Reach up high with both arms!',
    },
    {
      time: 93,
      text: 'Number 1! Reach up high with both arms, stretch toward the sky!',
    },
    {
      time: 96,
      text: 'Reach over to the right side, feel the stretch in your side!',
    },
    {
      time: 99,
      text: 'Reach over to the left side, stretch like a beautiful rainbow!',
    },
    {
      time: 102,
      text: 'Number 2! Reach up high with both arms, you are doing great!',
    },
    {
      time: 105,
      text: 'Reach over to the left side, feel the stretch in your side!',
    },
    {
      time: 108,
      text: 'Reach over to the right side, stretch like a beautiful rainbow!',
    },
    {
      time: 111,
      text: 'Number 3! Reach up high with both arms, stay focused!',
    },
    {
      time: 114,
      text: 'Reach over to the right side, feel the stretch in your side!',
    },
    {
      time: 117,
      text: 'Reach over to the left side, stretch like a beautiful rainbow!',
    },
    {
      time: 120,
      text: 'Number 4! Reach up high with both arms, keep going!',
    },
    {
      time: 123,
      text: 'Reach over to the left side, feel the stretch in your side!',
    },
    {
      time: 126,
      text: 'Reach over to the right side, stretch like a beautiful rainbow!',
    },
    {
      time: 129,
      text: 'Number 5! Reach up high with both arms, you are strong!',
    },
    {
      time: 132,
      text: 'Reach over to the right side, feel the stretch in your side!',
    },
    {
      time: 135,
      text: 'Reach over to the left side, stretch like a beautiful rainbow!',
    },
    {
      time: 138,
      text: 'Number 6! Reach up high with both arms, almost there!',
    },
    {
      time: 141,
      text: 'Reach over to the left side, feel the stretch in your side!',
    },
    {
      time: 144,
      text: 'Reach over to the right side, stretch like a beautiful rainbow!',
    },
    {
      time: 147,
      text: 'Great job! Take a deep breath and shake out your arms.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 150,
      text: 'Take a deep breath in and out, you are building incredible flexibility!',
    },
    {
      time: 153,
      text: 'Shake out your arms and shoulders, get ready for the final round!',
    },
    {
      time: 156,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 159,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 3 - 6 cycles
    {
      time: 162,
      text: 'Stand with your feet apart, arms at your sides!',
    },
    {
      time: 165,
      text: 'Get ready to reach up high and make beautiful rainbows!',
    },
    {
      time: 168,
      text: 'Perfect rainbow position! Reach up high with both arms!',
    },
    {
      time: 171,
      text: 'Number 1! Reach up high with both arms, stretch toward the sky!',
    },
    {
      time: 174,
      text: 'Reach over to the right side, feel the stretch in your side!',
    },
    {
      time: 177,
      text: 'Reach over to the left side, stretch like a beautiful rainbow!',
    },
    {
      time: 180,
      text: 'Number 2! Reach up high with both arms, you are doing great!',
    },
    {
      time: 183,
      text: 'Reach over to the left side, feel the stretch in your side!',
    },
    {
      time: 186,
      text: 'Reach over to the right side, stretch like a beautiful rainbow!',
    },
    {
      time: 189,
      text: 'Number 3! Reach up high with both arms, stay focused!',
    },
    {
      time: 192,
      text: 'Reach over to the right side, feel the stretch in your side!',
    },
    {
      time: 195,
      text: 'Reach over to the left side, stretch like a beautiful rainbow!',
    },
    {
      time: 198,
      text: 'Number 4! Reach up high with both arms, keep going!',
    },
    {
      time: 201,
      text: 'Reach over to the left side, feel the stretch in your side!',
    },
    {
      time: 204,
      text: 'Reach over to the right side, stretch like a beautiful rainbow!',
    },
    {
      time: 207,
      text: 'Number 5! Reach up high with both arms, you are strong!',
    },
    {
      time: 210,
      text: 'Reach over to the right side, feel the stretch in your side!',
    },
    {
      time: 213,
      text: 'Reach over to the left side, stretch like a beautiful rainbow!',
    },
    {
      time: 216,
      text: 'Number 6! Reach up high with both arms, almost there!',
    },
    {
      time: 219,
      text: 'Reach over to the left side, feel the stretch in your side!',
    },
    {
      time: 222,
      text: 'Reach over to the right side, stretch like a beautiful rainbow!',
    },
    {
      time: 225,
      text: 'Incredible work! You are done! You just completed all three sets!',
    },
    // COMPLETION
    {
      time: 228,
      text: 'Amazing work! You did 18 rainbow reaches and built incredible flexibility!',
    },
    {
      time: 231,
      text: 'You are getting super flexible and strong! You are a rainbow master!',
    },
    {
      time: 234,
      text: 'Great job, flexibility champion! You are building incredible skills!',
    },
  ],
};
